import script from "./ProductsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTab.vue?vue&type=script&setup=true&lang=js"

import "./ProductsTab.vue?vue&type=style&index=0&id=a520499e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a520499e"]])

export default __exports__